import {Platform, TextStyle, ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';

export function getStyleDescriptor(): {
  [index: string]: ViewStyle & TextStyle;
} {
  return {
    headerView: {
      marginLeft: Styles.Spacing.m3,
    },
    container: {
      backgroundColor: '#fff',
      paddingHorizontal: Styles.Spacing.m3,
      borderRadius: Styles.Spacing.m2,
      shadowRadius: 2,
      alignItems: 'center',
      marginBottom: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m3,
      marginHorizontal: Styles.Spacing.m3,
      flexDirection: 'row',
      ...getLayoutDescriber().shadowStyles().shadow,
      minHeight: Styles.MinTouchableArea,
    },
    titleText: {
      fontSize: Styles.Fonts.headerFont,
      fontWeight: '600',
      color: Styles.darkColor,
      marginLeft: Styles.Spacing.m3,
    },

    snackButtonText: {
      fontFamily: Styles.FontFamily.figtreeRegular,

      fontSize: Styles.Fonts.f7,
      fontWeight: '600',
    },
    revolveButtonStyle: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '600',
      fontSize: Styles.Fonts.f7,
    },
    snackButton: {
      marginBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
      borderWidth: 1,
      marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
    },

    revolveMainTxt: {
      fontWeight: '700',
      fontSize: 18,
      color: Styles.black,
      fontFamily: Styles.FontFamily.comodoVintage,
    },
    cardNumber: {
      color: Styles.lightGray,
      fontSize: Styles.Fonts.f1,
    },
    revolveAddTxt: {
      fontWeight: '400',
      fontSize: 18,
      color: Styles.black,
    },

    starIconView: {},
    invite: {
      borderRadius: 32,
      borderWidth: Platform.OS === 'android' ? 1.2 : 1,
      paddingVertical: 8,
      paddingHorizontal: 24,
      marginTop: 20,
      marginBottom: 16,
      overflow: 'hidden',
    },
    iconView: {
      width: Styles.Spacing.m4,
      backgroundColor: Styles.primaryColor,
      height: Styles.Spacing.m4,
      alignItems: 'center',
      borderRadius: Styles.Spacing.m2,
      justifyContent: 'center',
    },
    snackDescriptionText: {
      fontWeight: '400',
      marginVertical: Styles.Spacing.m1,
      color: Styles.darkColor,
      fontSize: Styles.Fonts.sectionHeader,
      textAlign: 'left',
    },
    label: {
      fontSize: Styles.Fonts.f1,
      color: Styles.darkColor,
    },
  };
}

export default {
  getStyleDescriptor,
};
